// @flow
import React, { type Node } from 'react';
import './LetteringTemplate.scss';

type Props = {
  children: Node,
};

const LetteringTemplate = ({ children }: Props) => (
  <div className="LetteringTemplate">{children}</div>
);

export default LetteringTemplate;



// WEBPACK FOOTER //
// ./src/components/lettering/LetteringTemplate/LetteringTemplate.js